import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpEvent,
    HttpEventType,
    HttpHeaders,
    HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import {
    CreateUploadSessionRequest,
    CreateUploadSessionResponse,
    CommitStoryRequest
} from './story-upload.api';

import { ApiUrl } from '../../../shared/models/apiurl.models';

@Injectable({ providedIn: 'root' })
export class StoryUploadService {
    private options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.apiUrl.getJWTToken(),
        }),
    };

    private readonly CREATE_SESSION_URL = this.apiUrl.getCreateSessionUrl();
    private readonly COMMIT_URL = this.apiUrl.getCommitUrl();
    private readonly CANCEL_URL = this.apiUrl.getCancelUrl();
    private readonly PRESIGN_URL = this.apiUrl.getPresignUrl();

    constructor(private http: HttpClient, private apiUrl: ApiUrl) {}

    createSession(req: CreateUploadSessionRequest): Observable<CreateUploadSessionResponse> {
        return this.http.post<CreateUploadSessionResponse>(this.CREATE_SESSION_URL, req, this.options);
    }

    /**
     * Upload to S3 presigned URL with progress (PUT).
     * IMPORTANT: do NOT send Authorization header here.
     */
    uploadToPresignedUrl(uploadUrl: string, file: File): Observable<number> {
        const headers = new HttpHeaders({
            'Content-Type': file.type || 'application/octet-stream'
        });

        const request = new HttpRequest('PUT', uploadUrl, file, {
            headers,
            reportProgress: true,
            responseType: 'text',
        });

        return this.http.request(request).pipe(
            filter((e: HttpEvent<any>) =>
                e.type === HttpEventType.UploadProgress || e.type === HttpEventType.Response
            ),
            map((e: HttpEvent<any>) => {
                if (e.type === HttpEventType.UploadProgress) {
                    const total = e.total != null ? e.total : (file.size || 1);
                    return Math.round((100 * e.loaded) / total);
                }
                return 100;
            })
        );
    }

    commitStory(body: CommitStoryRequest): Observable<any> {
        return this.http.post<any>(this.COMMIT_URL, body, this.options);
    }

    cancelSession(session_id: string): Observable<any> {
        return this.http.post<any>(this.CANCEL_URL, { session_id }, this.options);
    }

    getPresignUrl(key: string): Observable<any> {
        return this.http.post<any>(this.PRESIGN_URL, { key }, this.options);
    }
}
